import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://vzs2ssw4ee.execute-api.us-east-2.amazonaws.com/prod/',
});

export const apiTest = axios.create({
  baseURL: 'http://localhost:3000/dev',
});
